const SIGN_OUT_AND_CLEAR_ALL_REDUCERS = "SIGN_OUT_AND_CLEAR_ALL_REDUCERS";

const signOutAndClearAllReducers = {
  SIGN_OUT_AND_CLEAR_ALL_REDUCERS,
};
export default signOutAndClearAllReducers;
